module.exports = __webpack_public_path__ + "static/media/img-talent-manager-desktop@2x.d10cc137.png";